module.exports = {"SubTexture":[{"width":145,"y":248,"height":145,"name":"light_bac","x":827},{"width":824,"y":1,"height":680,"name":"5logo_part1","x":1},{"width":219,"y":683,"height":107,"name":"btn_play_first_screen","x":1},{"width":219,"y":792,"height":107,"name":"btn_play_first_screen_hover","x":1},{"width":128,"y":1,"height":245,"name":"cube_shadow","x":827},{"width":116,"y":395,"height":137,"name":"cub","x":827}],"width":1024,"height":1024,"name":"introscreen","imagePath":"introscreen_tex.png"}


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/2x/introscreen_tex.json
// module id = 228
// module chunks = 0